import { useQuery } from "@tanstack/react-query";
import { listOrgUsers } from "@/lib/admin/concierge-api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type Props = {
  orgId: string;
  value: string | null;
  onChange: (userId: string) => void;
  excludeExisting?: boolean;
  disabled?: boolean;
};

export function TargetUserPicker({ orgId, value, onChange, excludeExisting, disabled }: Props) {
  const { data = [], isLoading } = useQuery({
    queryKey: ["concierge", "admin", "org-users", orgId],
    queryFn: () => listOrgUsers(orgId),
    staleTime: 30_000,
  });

  const options = excludeExisting ? data.filter((o) => !o.has_site) : data;

  return (
    <Select value={value ?? undefined} onValueChange={onChange} disabled={disabled || isLoading}>
      <SelectTrigger>
        <SelectValue placeholder={isLoading ? "Loading users…" : "Select a user"} />
      </SelectTrigger>
      <SelectContent>
        {options.length === 0 && (
          <div className="px-3 py-2 text-sm text-muted-foreground">No eligible users.</div>
        )}
        {options.map((u) => (
          <SelectItem key={u.user_id} value={u.user_id}>
            {u.handle}
            {u.has_site && !excludeExisting ? " · has site" : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default TargetUserPicker;
